module.exports = __webpack_public_path__ + "media/images/client_logos/logo_heineken_200-cfc9339568607f68969379cbf28b56ae.png";